import api from './api';

// Inventarios (fechas) disponibles para prep ordering
export const getInventoriesForPrepOrdering = async (storeId) => {
  try {
    const response = await api.get('/prep-ordering/inventories', { params: { storeId } });
    return response.data;
  } catch (error) {
    console.error('Error al obtener inventarios para prep ordering:', error);
    throw error;
  }
};

// Calcular sugerencias de preparación
export const calculatePrepSuggestions = async (inventoryId, storeId) => {
  try {
    const response = await api.post('/prep-ordering/calculate', { inventoryId, storeId });
    return response.data;
  } catch (error) {
    console.error('Error al calcular sugerencias de preparación:', error);
    throw error;
  }
};

// Enviar la lista de preparación a cocina
export const sendPrepEmail = async (payload) => {
  try {
    const response = await api.post('/prep-ordering/send-email', payload);
    return response.data;
  } catch (error) {
    console.error('Error al enviar la lista de preparación:', error);
    throw error;
  }
};